import React from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import './ProfileIcon.scss'
import { logout } from '../../redux/reducers/authReducer';

const ProfileIcon = () => {
    const auth = useAppSelector((state) => state.authReducer)
    const dispatch = useAppDispatch()
    return (
        <div className='profile-bar'>
            <div className="visible">
                <div className="image">
                    {!!auth.user ?
                        <img src={auth.user.avatar} alt="" />: <AccountCircleIcon sx={{width: 50, height: 50}}/>
                }
                </div>
            </div>
            <div className="menu">
                    {
                        !!auth.user ? 
                        <ul>
                            <li>
                                <Link to='/profile'>Profile</Link>
                            </li>
                            <li>
                                <Link to='/' onClick={() => dispatch(logout())}>Logout</Link>
                            </li>
                        </ul> : <ul>
                            <li>
                                <Link to='/register'>Create an acount</Link>
                            </li>
                            <li>
                                <Link to='/login'>Sign in</Link>
                            </li>
                        </ul>
                    }
            </div>
        </div>
    )
}

export default ProfileIcon